import has from 'lodash/has.js';
import isEmpty from 'lodash/isEmpty.js';

/** Normalize instructor-review answers for the shared answer renderer. */
export function parseQuizReviewQuestions(item) {
    return item.map(question => {
        const multipleAnswer = question.type.includes('answer');
        const hasAnswerObject = has(question.question, 'answers');
        const freeForm = question.type === 'free_form';

        question.question.selected_answer = [];
        question.question.finalized_at = null;
        question.question.finalized = false;
        question.question.isChanging = false;

        // If Show Possible Answers List is false, answers object is not present

        if (hasAnswerObject && question.question.answers.some(answer => !answer.display_order)) {
            question.question.answers.forEach((answer, index) => (answer.display_order = index));
        }

        if (freeForm) {
            question.question.answer_body = null;
        }

        if (!isEmpty(question.quiz_attempt_answers)) {
            let selectedAnswer;

            if (!multipleAnswer) {
                [selectedAnswer] = question.quiz_attempt_answers;

                if (hasAnswerObject) {
                    const index = question.question.answers.findIndex(
                        answer => Number(answer.id) === Number(selectedAnswer.answer_id)
                    );

                    if (index >= 0) {
                        question.question.answers[index].selected = true;

                        question.question.selected_answer = question.question.answers[index].display_order;
                    }
                }

                if (selectedAnswer.finalized_at != null) {
                    question.question.finalized = true;
                    question.question.finalized_at = selectedAnswer.finalized_at;
                }
            }

            if (multipleAnswer) {
                selectedAnswer = [];

                if (hasAnswerObject) {
                    question.quiz_attempt_answers.forEach(answer => {
                        const index = question.question.answers.findIndex(
                            possibleAnswer => Number(possibleAnswer.id) === Number(answer.answer_id)
                        );

                        if (index >= 0) {
                            question.question.answers[index].selected = true;

                            selectedAnswer.push(question.question.answers[index].display_order);

                            question.question.selected_answer = selectedAnswer;
                        }
                    });
                }

                if (question.quiz_attempt_answers.some(answer => answer.finalized_at != null)) {
                    const index = question.quiz_attempt_answers.findIndex(answer => answer.finalized_at != null);

                    question.question.finalized = true;
                    question.question.finalized_at = question.quiz_attempt_answers[index].finalized_at;
                }
            }

            if (freeForm) {
                if (hasAnswerObject && question.question.answers.length > 0) {
                    question.quiz_attempt_answers.forEach(answer => {
                        question.question.answers[0].answer_body = answer.answer_body;

                        question.question.answers[0].answer_attempt_id = answer.id;

                        question.question.answers[0].finalized = answer.finalized;

                        question.question.answers[0].finalized_at = answer?.finalized_at;
                    });
                }
            }
        }

        return question;
    });
}
